import React from "react";

import BalloonFeelGood from "./../svgs/BalloonFeelGood";
import BalloonImprove from "./../svgs/BalloonImprove";
import BalloonAppreciate from "./../svgs/BalloonAppreciate";

import OneThing from "./OneThing";

const threeThingsArray = [
    {
        balloon: <BalloonFeelGood />,
        text: "I’m feeling good about...",
        classes: "one-thing__balloon--good"
    },
    {
        balloon: <BalloonImprove />,
        text: "I want to improve...",
        classes: "one-thing__balloon--improve"
    },
    {
        balloon: <BalloonAppreciate />,
        text: "A teammate did that I appreciated...",
        classes: "one-thing__balloon--appreciate"
    }
];

const ThreeThings = () =>
    threeThingsArray.map((thing, i) => {
        return <OneThing key={i} {...thing} />;
    });

export default ThreeThings;



// WEBPACK FOOTER //
// ./src/components/landingPage/ThreeThings.jsx